goog.provide("shadow.js.shim.module$$mui$material$Popper$default");
shadow.js.shim.module$$mui$material$Popper$default = shadow.js.shim.module$$mui$material$Popper.default;
